import { getI18n } from "react-i18next";
import { RouteComponentProps } from "react-router";
import { Appointment, AppointmentTime } from "Types/api/Appointment";
import { ApiVehicle } from "Types/api/Vehicle";

export interface ContinueDealWithStateProps extends RouteComponentProps {
    uuid: string;
    appointmentDate: Date;
    appointmentTime: string;
    dealerPhone: string;
    vehicle: ApiVehicle;
    scheduleAppointment: (date: Date, time: Appointment["time"]) => void;
    removeAppointment: () => void;
}

export const getAppointmentTimeToDisplay = (time: Appointment["time"]) => {
    const i18n = getI18n();
    const timeTodisplay = {
        [AppointmentTime.InTheAfternoon]: i18n.t("ContinueDeal.ScheduleAppointment.afternoon"),
        [AppointmentTime.InTheEvening]: i18n.t("ContinueDeal.ScheduleAppointment.evening"),
        [AppointmentTime.InTheMorning]: i18n.t("ContinueDeal.ScheduleAppointment.morning"),
    };

    return timeTodisplay[time] || "";
};

export const trimToJustDate = (date: Date) => {
    return date.toISOString().slice(0, 10);
};

export const buildAppointmentRequestBody = (date: Date, time: Appointment["time"]) => {
    return {
        date: trimToJustDate(date),
        home: false,
        time,
    };
};

export const appointmentIsExpired = (appointment: Date) => {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    return appointment < now;
};

export const validateSchedule = (date: Date | null, time: Appointment["time"] | null) => {
    const i18n = getI18n();

    if (!date) {
        return {
            isValid: false,
            message: i18n.t("ContinueDeal.ScheduleAppointment.dateRequiredErrorMessage"),
        };
    }
    if (!time) {
        return {
            isValid: false,
            message: i18n.t("ContinueDeal.ScheduleAppointment.timeRequiredErrorMessage"),
        };
    }
    if (appointmentIsExpired(date)) {
        return {
            isValid: false,
            message: i18n.t("ContinueDeal.ScheduleAppointment.futureDateErrorMessage"),
        };
    }
    return { isValid: true };
};
